import ButtonPrimary from './ButtonPrimary'
import ButtonSecondary from './ButtonSecondary'

export default ButtonPrimary
export { ButtonSecondary }
